import { useEffect, useState } from "react";

// Lightweight scrollspy (native IntersectionObserver, no libraries).
// Observes elements carrying [data-spy]; returns the id of the block
// whose top is nearest below the sticky nav offset.
// `deps` re-rulează efectul când se schimbă filtrele (ex. DE POST / căutare),
// iar targeturile sunt re-citite la fiecare calcul — elementele demontate
// de filtre nu mai sunt luate în calcul (nu mai „sare” pe o secțiune greșită).
export const useScrollSpy = (offset = 160, deps = []) => {
  const [activeSub, setActiveSub] = useState(null);

  useEffect(() => {
    const compute = () => {
      const targets = Array.from(document.querySelectorAll("[data-spy]"));
      if (!targets.length) return;
      const off = navOffset() + 20;
      const nearBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 4;
      let current = targets[0];
      for (const el of targets) {
        const top = el.getBoundingClientRect().top;
        if (top - off <= 1) current = el;
      }
      // La capătul paginii, secțiunile scurte de jos nu mai ajung la linia de
      // offset — activează ultima secțiune ca să nu rămână alta evidențiată.
      if (nearBottom) current = targets[targets.length - 1];
      setActiveSub(current.getAttribute("data-spy"));
    };

    compute();
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        compute();
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, ...deps]);

  return activeSub;
};

// Sticky-stack height depending on breakpoint.
export const navOffset = () =>
  typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
    ? 64
    : 150;

// Smooth scroll to an element id accounting for sticky offset.
export const scrollToId = (id, offset) => {
  if (offset === undefined) offset = navOffset();
  const el = document.getElementById(id);
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: "smooth" });
};
